import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, 
    TableRow, Button, IconButton, Stack, Typography, 
    Box, Tooltip, Paper
} from '@mui/material';
import { 
    FaPlus, FaArrowUp, FaArrowDown, FaEdit, 
    FaLink, FaListOl, FaWrench 
} from 'react-icons/fa';

const BoardMemberManagement = ({ 
    members, 
    onAdd, 
    onEdit, 
    onDelete, 
    onMove, 
    getDisplayName 
}) => {
    return (
        <Paper 
            elevation={0} 
            sx={{ 
                mb: 4, 
                borderRadius: '12px', 
                overflow: 'hidden',
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,0,0.05)'
            }}
        >
            <Box sx={{ 
                p: 2, 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid rgba(0,0,0,0.05)',
                bgcolor: 'rgba(0,0,0,0.01)'
            }}>
                <Typography variant="h6" color="primary">Vorstandsteam</Typography>
                <Button 
                    variant="contained" 
                    size="small" 
                    startIcon={<FaPlus />} 
                    onClick={onAdd}
                    sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                    Neu
                </Button>
            </Box>
            <Box sx={{ p: 0 }}>
                <TableContainer sx={{ overflowAnchor: 'none' }}>
                    <Table size="small">
                        <TableHead sx={{ bgcolor: 'rgba(0,0,0,0.02)' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary', py: 1.5 }}>NAME</TableCell>
                                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary', display: { xs: 'none', md: 'table-cell' } }}>POSITION</TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary' }}><FaListOl /></TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary' }}><FaWrench /></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {members.map((m, idx) => (
                                <TableRow 
                                    key={m._id || idx} 
                                    hover 
                                    sx={{ 
                                        '&:hover': { bgcolor: 'rgba(0,0,0,0.02) !important' },
                                        transition: 'background-color 0.2s'
                                    }}
                                >
                                    <TableCell sx={{ py: 1.5 }}>
                                        <Stack direction="row" spacing={1.5} alignItems="center">
                                            <Stack direction="row" sx={{ flexShrink: 0 }}>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === 0} 
                                                    onClick={() => onMove(idx, -1)}
                                                    sx={{ p: 0.5, color: 'text.secondary' }}
                                                >
                                                    <FaArrowUp fontSize="0.7rem" />
                                                </IconButton>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === members.length - 1} 
                                                    onClick={() => onMove(idx, 1)}
                                                    sx={{ p: 0.5, color: 'text.secondary' }}
                                                >
                                                    <FaArrowDown fontSize="0.7rem" />
                                                </IconButton>
                                            </Stack>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>
                                                    {getDisplayName(m)}
                                                    {m.playerId && (
                                                        <Tooltip title="Mit Spielerprofil verknüpft">
                                                            <Box component="span" sx={{ ml: 1 }}>
                                                                <FaLink fontSize="0.75rem" color="#17a2b8" />
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                                        <Box 
                                            component="span" 
                                            sx={{ 
                                                fontSize: '0.7rem', 
                                                px: 1.2, py: 0.4, 
                                                bgcolor: 'rgba(0,0,0,0.04)', 
                                                borderRadius: '6px',
                                                color: 'text.primary',
                                                fontWeight: 600,
                                                textTransform: 'uppercase',
                                                letterSpacing: 0.5
                                            }}
                                        >
                                            {m.position}
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>{m.order}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" color="primary" onClick={() => onEdit(m)} sx={{ bgcolor: 'rgba(211, 47, 47, 0.05)', '&:hover': { bgcolor: 'primary.main', color: 'white' } }}>
                                            <FaEdit fontSize="0.85rem" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Paper>
    );
};

export default BoardMemberManagement;
